import { useDynamicEntity } from './useDynamicEntity';
import { useAuth } from './index';

const useCompanies = ({ paginated = false } = {}) => {
  const { user } = useAuth();
  
  const dynamicHook = useDynamicEntity({
    entityType: 'companies',
    gqlEntityKey: 'companies',
    queryName: 'GET_COMPANIES_QUERY',
    createMutation: 'CREATE_COMPANY_MUTATION',
    updateMutation: 'UPDATE_COMPANY_MUTATION',
    deleteMutation: 'DELETE_COMPANY_MUTATION',
    transformData: (company) => ({
      ...company,
      name: company.name,
      emailAddressOfRepresentative: company.email_address_of_representative,
      nameOfRepresentative: company.name_of_representative_,
      phoneOfRepresentative: company.phone_of_representative,
    }),
    transformFormData: (formData) => ({
      name: formData.name,
      email_address_of_representative: formData.email_address_of_representative || null,
      name_of_representative_: formData.name_of_representative_ || null,
      phone_of_representative: formData.phone_of_representative || null,
    }),
    customWhereCondition: user?.role === 'ROOT' ? {} : { id: { _eq: user?.companyId } },
    // Companies pattern configuration
    mutationPattern: 'companies',
    createVariableName: 'data',
    updateVariableName: 'data',
    serverPagination: paginated,
    aggregateKey: paginated ? 'companies_aggregate' : null,
  });

  return {
    ...dynamicHook,
    isRootUser: user?.role === 'ROOT',
  };
};

export { useCompanies };
